export default __webpack_public_path__ + "static/union-9e27f3dce973802c78c20db74bbbcbf0.svg";